<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'Direct'">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true }" fxLayout="column">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
          <h2 fxFlex class="nomargin">Payout History</h2>
        </div>
      </sbnb-page-header>
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
        <h2 fxFlex class="nomargin">Payout History</h2>
      </div>
    </app-feature-flag-tabs>

    <div>
      <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'direct-payout-history'"></sbnb-helptext-wrapper>
      <sbnb-helptext-wrapper [area]="'content'" [pageId]="'direct-payout-history'"></sbnb-helptext-wrapper>
    </div>

    <ng-template *ngIf="isMobile$ | async" [ngTemplateOutlet]="mobileStats"></ng-template>

    <ng-container *ngIf="!(isMobile$ | async)">
      <ng-template [ngTemplateOutlet]="stats"></ng-template>
    </ng-container>

    <mat-spinner *ngIf="loading" [diameter]="32"></mat-spinner>

    <div [hidden]="loading">
      <div
        class="inbox__filters-container"
        fxLayout="row wrap"
        fxLayout.lt-lg="column"
        fxLayoutGap="12px"
        fxLayoutAlign="start start"
        fxLayoutAlign.lt-lg="start stretch">
        <div fxFlex>
          <sbnb-filter
            #filterComponent
            componentName="payouts"
            [customEndpoint]="this.filtersUrl"
            [hideSaveSegment]="true"
            (filterChanged)="handleFilterChanged($event)"
            (reset)="handleFilterReset()"></sbnb-filter>
        </div>
        <div fxFlex="320px" fxFlex.lt-lg fxLayout fxLayoutAlign="start start" fxLayoutGap="12px">
          <sbnb-search-bar
            fxFlex
            placeholderText="Search for reservation code..."
            [debounceTimeMs]="1500"
            (searchChanged)="handleSearchUpdated($event)"></sbnb-search-bar>
        </div>

        <div *ngIf="!(isMobile$ | async)" style="width: 100px">
          <sbnb-button
            *ngIf="expandAction === true"
            [fullWidth]="true"
            type="secondary"
            size="mini"
            (clicked)="accordion.openAll(); expandAction = !expandAction">
            Expand all
          </sbnb-button>
          <sbnb-button
            *ngIf="expandAction === false"
            [fullWidth]="true"
            type="secondary"
            size="mini"
            (clicked)="accordion.closeAll(); expandAction = !expandAction">
            Collapse all
          </sbnb-button>
        </div>
      </div>

      <ng-template *ngIf="!(isMobile$ | async)" [ngTemplateOutlet]="desktopTable"></ng-template>
      <ng-template *ngIf="isMobile$ | async" [ngTemplateOutlet]="mobileTable"></ng-template>
    </div>

    <sbnb-no-items
      *ngIf="payoutHistory.length === 0 && !loading"
      [text]="searchQuery || activeFilters ? 'You have no payouts matching this criteria.' : 'You have no payouts.'"
      subtext="Your payouts will usually be sent to you the next day after checkin."></sbnb-no-items>

    <sbnb-pagination
      *ngIf="totalPages && currentPage && totalPages > 1"
      position="end"
      [pageCount]="totalPages"
      [currentPage]="currentPage"
      (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
  </main>
</div>

<ng-template #mobileStats>
  <div *ngIf="stats$ | async as stats">
    <swiper-container
      slides-per-view="1"
      navigation="false"
      pagination="true"
      pagination-clickable="true"
      keyboard="true"
      class="dialog-image-swiper">
      <swiper-slide *ngIf="stats.balance">
        <div class="swiper-slide-container">
          <div style="display: flex; justify-content: center; align-items: center; height: 100%">
            <div class="stats-box text-center" fxFlex>
              <h4>Upcoming payouts</h4>
              <h1>{{ stats.balance.formatted_string }}</h1>
              <h5>Today</h5>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide *ngIf="stats.paid">
        <div class="swiper-slide-container">
          <div class="stats-box text-center" fxFlex>
            <h4>Paid</h4>
            <h1>{{ stats.paid.formatted_string }}</h1>
            <h5>Last 30 days</h5>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide *ngIf="stats.scheduled">
        <div class="swiper-slide-container">
          <div class="stats-box text-center" fxFlex>
            <h4>Scheduled</h4>
            <h1>{{ stats.scheduled.formatted_string }}</h1>
            <h5>Next 30 days</h5>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</ng-template>

<ng-template #stats>
  <div
    *ngIf="stats$ | async as stats"
    class="stats"
    fxLayout
    fxLayoutGap="24px"
    fxLayout.lt-md="column"
    fxLayoutGap.lt-md="0px">
    <div *ngIf="stats.balance" class="stats-box text-center" fxFlex>
      <h4>Upcoming payouts</h4>
      <h1>{{ stats.balance.formatted_string }}</h1>
      <h5>Today</h5>
    </div>

    <div *ngIf="stats.paid" class="stats-box text-center" fxFlex>
      <h4>Paid</h4>
      <h1>{{ stats.paid.formatted_string }}</h1>
      <h5>Last 30 days</h5>
    </div>

    <div *ngIf="stats.scheduled" class="stats-box text-center" fxFlex>
      <h4>Scheduled</h4>
      <h1>{{ stats.scheduled.formatted_string }}</h1>
      <h5>Next 30 days</h5>
    </div>
  </div>
</ng-template>

<ng-template #desktopTable>
  <div fxLayout fxLayoutGap="18px" fxHide.lt-md class="rules__rule-header">
    <div fxFlex="0 0 80px">Status</div>
    <div fxFlex fxFlex="0 0 96px">Payout Date</div>
    <div fxFlex>Property</div>
    <div fxFlex>Payout Method</div>
    <div fxFlex="0 0 126px">Reservation Code</div>
    <div fxFlex="0 0 80px" class="text-right">Amount</div>
    <div fxFlex="0 0 20px"></div>
  </div>

  <mat-accordion multi>
    <mat-expansion-panel *ngFor="let payout of payoutHistory" class="mat-elevation-z0 payout-history-expansion">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <div fxLayoutGap="18px" fxLayoutAlign="start center" fxFlex>
          <div fxFlex="0 0 80px">
            <div
              class="badge text-center"
              [ngClass]="{
                'badge-grass': payout.status === PayoutHistoryStatus.SETTLED,
                'badge-lemon': payout.status === PayoutHistoryStatus.SCHEDULED
              }">
              {{ payout.status | humanize }}
            </div>
          </div>
          <div fxFlex fxFlex="0 0 96px" class="text-right">
            {{ payout.payout_at | date: 'mediumDate' }}
          </div>
          <div fxFlex class="ellipsis">{{ payout.property_name }}</div>
          <div fxFlex class="ellipsis">
            {{ payout.account_holder_name }}
            <sbnb-cs-debug-item
              *ngIf="payout.account_holder_id"
              [link]="
                'https://balanceplatform-live.adyen.com/balanceplatform/accounts/account-holders/' +
                payout.account_holder_id
              "
              style="font-size: 10px"></sbnb-cs-debug-item>
          </div>
          <div fxFlex="0 0 126px">
            <a
              class="strong grass-darker"
              [routerLink]="['/inbox/segments/default', { query: payout.reservation_code }]">
              {{ payout.reservation_code }}
            </a>
          </div>
          <div fxFlex="0 0 80px" class="text-right">{{ payout.amount.formatted_string }}</div>
          <div fxFlex="0 0 20px"></div>
        </div>
      </mat-expansion-panel-header>

      <!-- Child items-->
      <ng-container *ngIf="payout.events">
        <div *ngFor="let child of payout.events" fxLayoutGap="18px" class="payout-child-item">
          <div fxFlex="0 0 80px"></div>
          <div fxFlex fxFlex="0 0 96px" class="text-right">{{ child.occurred_at | date: 'mediumDate' }}</div>
          <div fxFlex class="ellipsis" fxLayout="column">
            <div class="child-title">{{ child.title }}</div>
            <div>{{ child.details }}</div>
          </div>
          <div fxFlex="0 0 80px" class="text-right">{{ child.hide_amount ? '' : child.amount.formatted_string }}</div>
          <div fxFlex="0 0 28px"></div>
        </div>
      </ng-container>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>

<ng-template #mobileTable>
  <mat-accordion multi>
    <mat-expansion-panel *ngFor="let payout of payoutHistory" class="mat-elevation-z0 payout-history-expansion">
      <mat-expansion-panel-header [collapsedHeight]="'120px'" [expandedHeight]="'120px'">
        <div fxFlex fxLayout="column">
          <div fxFlex fxLayoutGap="18px" fxFlex class="strong">
            <div fxFlex="0 0 80px">
              <div
                class="badge text-center"
                [ngClass]="{
                  'badge-grass': payout.status === PayoutHistoryStatus.SETTLED,
                  'badge-lemon': payout.status === PayoutHistoryStatus.SCHEDULED
                }">
                {{ payout.status | humanize }}
              </div>
            </div>
            <div fxFlex fxFlex="0 0 100px">{{ payout.latest_activity_at | date: 'mediumDate' }}</div>
            <div fxFlex class="text-right">{{ payout.amount.formatted_string }}</div>
          </div>

          <div fxFlex class="mob-reservation-code">
            <a
              class="strong grass-darker"
              [routerLink]="['/inbox/segments/default', { query: payout.reservation_code }]">
              {{ payout.reservation_code }}
            </a>
          </div>
          <div fxFlex class="mob-property-name ellipsis">{{ payout.property_name }}</div>
          <div fxFlex class="mob-account-name ellipsis">{{ payout.account_holder_name }}</div>
        </div>
      </mat-expansion-panel-header>

      <!-- Child items-->
      <ng-container *ngIf="payout.events">
        <div *ngFor="let child of payout.events" fxLayout="column" class="payout-child-item">
          <div fxLayoutGap="18px">
            <div fxFlex fxFlex="0 0 100px" style="padding-left: 8px">{{ child.occurred_at | date: 'mediumDate' }}</div>
            <div fxFlex fxLayout="column">
              <div class="child-title">{{ child.title }}</div>
            </div>
            <div fxFlex="0 0 80px" class="text-right">
              {{ child.hide_amount ? '' : child.amount.formatted_string }}
            </div>
          </div>
          <div style="padding-left: 8px">{{ child.details }}</div>
        </div>
      </ng-container>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
